import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardContent from "../atoms/DashboardContent";
import { useParams } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { handleChange, handleSubmit } from "../../atoms/Upsert";
import Input from "../../atoms/Input";
import Select from "../../atoms/Select";
import Button from "../../atoms/Button";
import ButtonCancel from "../../atoms/ButtonCancel";
import ButtonSave from "../../atoms/ButtonSave";
import * as generalHelper from "../../../helpers/generalHelper";
import { getStatuses } from "../../../store/slice/statusSlice";

import {
    getDeviceType,
    insertDeviceType,
    updateDeviceType,
    deleteDeviceType,
} from "../../../store/slice/deviceTypeSlice";
import routes from "../constants/routes";

export default function (props) {
    const dispatch = useDispatch();
    const [values, setValues] = useState({});
    const statuses = useSelector((state) => state.status.rows);
    const [redirect, setRedirect] = useState(false);
    const { id } = useParams();

    React.useEffect(() => {
        dispatch(getStatuses({ type: "Default" }));
        if (id) {
            dispatch(getDeviceType({ id: id })).then((response) => {
                setValues(response.payload);
            });
        }
    }, []);

    function Content(props) {
        const handleDelete = () => {
            dispatch(deleteDeviceType({ id })).then((response) => {
                setRedirect(`${routes.index}${routes.deviceType.root}`);
            });
        };

        return (
            <div className="card card-primary">
                <form
                    type="post"
                    onSubmit={(event) => {
                        handleSubmit(event, {
                            id: id,
                            values: values,
                            functions: {
                                insert: insertDeviceType,
                                update: updateDeviceType,
                            },
                            callback: {
                                function: setRedirect,
                                params: `${routes.index}${routes.deviceType.root}`,
                            },
                            dispatch: dispatch,
                        });
                    }}
                >
                    <div className="card-body row">
                        <div className="col-sm-6 col-md-4">
                            <Input
                                label="Name"
                                name="name"
                                value={values.name}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <Select
                                label="Status"
                                name="status_id"
                                options={statuses}
                                value={values.status_id}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-6">
                                {id > 0 && (
                                    <Button
                                        label="Delete"
                                        className="btn btn-danger"
                                        type="button"
                                        onClick={(event) => {
                                            handleDelete();
                                        }}
                                    />
                                )}
                            </div>
                            <div className="col-sm-6 text-right">
                                <ButtonCancel /> <ButtonSave />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    return (
        <div>
            {redirect && <Navigate to={redirect} />}
            <DashboardContent
                title={id ? "Edit Device Type" : "Create Device Type"}
                icon="fa fa-list"
                content={Content(props)}
                breadcrumb={[
                    {
                        label: "Devices",
                        to: `${routes.index}${routes.device.root}`,
                    },
                    {
                        label: "Device Types",
                        to: `${routes.index}${routes.deviceType.root}`,
                    },
                    { label: id ? "Edit" : "New" },
                ]}
            />
        </div>
    );
}
